<template>
        <div class="space-y-4">
          <h3 class="text-lg font-bold">Создание доктора для клиники #{{ clinicId }}</h3>
          <input v-model="form.user.full_name" placeholder="Имя и фамилия" class="input" required />
          <input v-model="form.user.phone" placeholder="Телефон" class="input" required />
          <input v-model="form.password" placeholder="Пароль" class="input" required />
          <input v-model="form.doctor.age" placeholder="Возраст" class="input" required />
          <input v-model="form.doctor.describe" placeholder="Описание" class="input" />
          <input v-model="form.doctor.knowledge" placeholder="Образование" class="input" />
          <input v-model="form.doctor.courses" placeholder="Курсы" class="input" />
          <input v-model="form.doctor.certificates" placeholder="Сертификаты" class="input" />
          <input v-model="form.doctor.services" placeholder="Услуги" class="input" />
          <input v-model="form.doctor.price" placeholder="Цена" class="input" required />
          <input v-model="form.doctor.speciality" placeholder="Специальность" class="input" required />
          <input v-model="form.doctor.cabinet" placeholder="Кабинет" class="input" required />

          <div class="bg-gray-100 rounded p-4 space-y-2">
            <h3 class="font-semibold text-gray-700">График работы</h3>
            <div
              v-for="(schedule, index) in form.doctor.schedules"
              :key="index"
              class="grid grid-cols-1 sm:grid-cols-4 gap-2 items-center"
            >
              <select v-model="schedule.week_day" class="input">
                <option v-for="day in weekdays" :key="day" :value="day">{{ day }}</option>
              </select>
              <input v-model="schedule.start_at" type="time" class="input" />
              <input v-model="schedule.end_at" type="time" class="input" />
              <label class="flex items-center space-x-1">
                <input v-model="schedule.is_day_off" type="checkbox" />
                <span>Выходной</span>
              </label>
              <button
                type="button"
                class="btn-sm bg-red-500 hover:bg-red-600"
                @click="removeSchedule(index)"
              >
                Удалить
              </button>
            </div>
            <button
              type="button"
              class="btn-sm bg-green-500 hover:bg-green-600 mt-2"
              @click="addSchedule"
            >
              + Добавить день
            </button>
          </div>

          <div class="flex justify-end space-x-3 mt-4">
            <button @click.prevent="submit" class="btn">Создать</button>
            <button @click.prevent="$emit('cancel')" class="btn-secondary">Отмена</button>
          </div>
        </div>
      </template>

      <script>
      import { registerUser } from "@/services/clinicMicroService";
import { ref } from "vue";
import { toast } from "vue3-toastify";

      export default {
        name: "DoctorCreateForm",
        props: {
          clinicId: {
            type: Number,
            required: true,
          },
        },
        emits: ["success", "cancel"],
        setup(props, { emit }) {
          const weekdays = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ];

          const form = ref({
            user: {
              full_name: "",
              phone: "",
              role: "doctor",
              clinic_id: props.clinicId,
            },
            password: "",
            doctor: {
              age: "",
              describe: "",
              knowledge: "",
              courses: "",
              certificates: "",
              services: "",
              price: "",
              speciality: "",
              cabinet: "",
              schedules: []
            },
          });

          const addSchedule = () => {
            form.value.doctor.schedules.push({
              week_day: "Monday",
              start_at: "09:00",
              end_at: "18:00",
              is_day_off: false,
            });
          };
          const removeSchedule = (index) => {
            form.value.doctor.schedules.splice(index, 1);
          };
          const submit = async () => {
            try {
              // Явно приводим нужные данные к числу
              const payload = {
                ...form.value,
                doctor: {
                  ...form.value.doctor,
                  age: Number(form.value.doctor.age),
                  price: Number(form.value.doctor.price),
                  cabinet: Number(form.value.doctor.cabinet),
                },
              };
              await registerUser(payload);
              toast.success("Доктор успешно создан!");
              emit("success");
            } catch (error) {
              toast.error("Ошибка создания доктора");
              console.error(error);
            }
          };
          return {
            form,
            weekdays,
            addSchedule,
            removeSchedule,
            submit,
          };
        },
      };
      </script>

      <style scoped>
      .input {
        @apply w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:ring-green-300;
      }
      .btn {
        @apply px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition;
      }
      .btn-secondary {
        @apply px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500 transition;
      }
      .btn-sm {
        @apply px-3 py-1 text-white rounded text-sm transition;
      }
      </style>
